import { render, staticRenderFns } from "./AccountVADialog.vue?vue&type=template&id=b1a8d168&scoped=true"
import script from "./AccountVADialog.vue?vue&type=script&lang=js"
export * from "./AccountVADialog.vue?vue&type=script&lang=js"
import style0 from "./AccountVADialog.vue?vue&type=style&index=0&id=b1a8d168&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a8d168",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1a8d168')) {
      api.createRecord('b1a8d168', component.options)
    } else {
      api.reload('b1a8d168', component.options)
    }
    module.hot.accept("./AccountVADialog.vue?vue&type=template&id=b1a8d168&scoped=true", function () {
      api.rerender('b1a8d168', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/dialog/AccountVADialog.vue"
export default component.exports